import { toObject } from "../../core/utils";

class HolidayPageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    return toObject(data);
  }
}

export default HolidayPageTransform;



// WEBPACK FOOTER //
// ./src/pages/holiday/holiday.transforms.js